import { History } from 'history';
import { FC, ReactNode, useLayoutEffect, useState } from 'react';
import { Router } from 'react-router';

interface CustomBrowserRouterProps {
  basename?: string;
  history: History;
  children: ReactNode;
}

const CustomBrowserRouter: FC<CustomBrowserRouterProps> = ({
  children,
  basename,
  history,
}) => {
  const [state, setState] = useState({
    action: history.action,
    location: history.location,
  });

  useLayoutEffect(() => history.listen(setState), [history]);

  return (
    <Router
      basename={basename}
      location={state.location}
      navigationType={state.action}
      navigator={history}
    >
      {children}
    </Router>
  );
};

export default CustomBrowserRouter;
